import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Chargement…</div>;
  if (!user) return <Navigate to="/login" replace />;
  // super_admin always has access
  if (roles && user.role !== "super_admin" && !roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
}
